<template>
  <VDropdown
    v-if="!onlyLogin && currentRoutePath != 'ValidateAlignPoints'"
    ref="paramsPopper"
    placement="top-end"
    popover-base-class="tooltip popover popover__Menu max-w-2xl"
  >
    <button
      id="label-help"
      v-tooltip.bottom="$t('generic.help')"
      class="border-gray-100 border-r flex items-center my-3 px-2 py-2 relative"
    >
      <IconWrap
        class="mx-2"
        label="help"
      >
        <IconHelp />
      </IconWrap>
    </button>
    <template #popper>
      <div class="max-w-2xl text-gray-400 tutorialContent">
        <h3 class="text-teal-100 tutorialHeader">
          <IconWrap
            class="mx-2"
            label="help"
            width="40"
            height="40"
          >
            <IconGraduation />
          </IconWrap>
          {{ $t('generic.tutorial') }} {{ PageTitle }}
        </h3>
        <hr class="border-gray-100 my-2">
        <VisitHome
          v-if="currentRoutePath == 'ExplorerMapVisit'"
          @get-page-title="helpTitle"
        />
        <VisitPhoto
          v-if="currentRoutePath == 'ExplorerVisitId'"
          @get-page-title="helpTitle"
        />
        <ContributeHome
          v-if="currentRoutePath == 'ExplorerMapContribute'"
          @get-page-title="helpTitle"
        />
        <ContributePhoto
          v-if="currentRoutePath == 'ExplorerContributeId'"
          @get-page-title="helpTitle"
        />
        <ContributeGeoLocation
          v-if="currentRoutePath == 'ProvideLocation'"
          @get-page-title="helpTitle"
        />
        <ContributeGeoDirection
          v-if="currentRoutePath == 'ProvideDirection'"
          @get-page-title="helpTitle"
        />
        <ContributeGeoAlign
          v-if="currentRoutePath == 'AlignPoints'"
          @get-page-title="helpTitle"
        />
        <ContributeGeoPerspective
          v-if="currentRoutePath == 'ImprovePerspective'"
          @get-page-title="helpTitle"
        />
        <ContributeGeoObservations
          v-if="currentRoutePath == 'ProvideObservation'"
          @get-page-title="helpTitle"
        />
        <ContributeGeoBravo
          v-if="currentRoutePath == 'Bravo'"
          @get-page-title="helpTitle"
        />
      </div>
    </template>
  </VDropdown>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import IconGraduation from '@/assets/images/icons/graduation';
import IconHelp from '@/assets/images/icons/Help';
import IconWrap from '@/assets/images/icons';
const VisitHome = defineAsyncComponent(() => import('@/components/tutorial/VisitHome'));
const VisitPhoto = defineAsyncComponent(() => import('@/components/tutorial/VisitPhoto'));
const ContributeHome = defineAsyncComponent(() => import('@/components/tutorial/ContributeHome'));
const ContributePhoto = defineAsyncComponent(() => import('@/components/tutorial/ContributePhoto'));
const ContributeGeoLocation = defineAsyncComponent(() => import('@/components/tutorial/ContributeGeoLocation'));
const ContributeGeoDirection = defineAsyncComponent(() => import('@/components/tutorial/ContributeGeoDirection'));
const ContributeGeoAlign = defineAsyncComponent(() => import('@/components/tutorial/ContributeGeoAlign'));
const ContributeGeoPerspective = defineAsyncComponent(() => import('@/components/tutorial/ContributeGeoPerspective'));
const ContributeGeoObservations = defineAsyncComponent(() => import('@/components/tutorial/ContributeGeoObservations'));
const ContributeGeoBravo = defineAsyncComponent(() => import('@/components/tutorial/ContributeGeoBravo'));

import { mapGetters } from 'vuex';

export default {
  name: 'NavHelp',

  components: {
    IconWrap,
    IconHelp,
    IconGraduation,
    VisitHome,
    VisitPhoto,
    ContributeHome,
    ContributePhoto,
    ContributeGeoLocation,
    ContributeGeoDirection,
    ContributeGeoAlign,
    ContributeGeoPerspective,
    ContributeGeoObservations,
    ContributeGeoBravo
  },

  props: {
    onlyLogin: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      PageTitle: null,
      currentRoutePath: ''
    };
  },

  computed: {
    ...mapGetters('user', ['isLoggedIn'])
  },

  watch: {
    // call again the method if the route changes
    '$route': {
      handler() {
        this.setRoutePath();
      },

      immediate: true
    }
  },

  methods: {
    helpTitle(currenttitle) {
      this.PageTitle = currenttitle;
    },

    setRoutePath() {
      this.currentRoutePath = this.$router.currentRoute.value.name;
    }
  }
};
</script>

<style lang="postcss">
.tutorialHeader {
  @apply flex items-center px-4 font-title font-semibold text-lg no-underline;
}

.tutorialContent {
  max-height: 350px;
  overflow-y: auto;
}
</style>
